export const routeCadastros = (routes, checkAuth) => {
    routes.push(
        {
            path: "/clientes",
            component: () =>
                import(/* webpackChunkName: "clientes" */ "../pages/cadastros/Clientes.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/cliente",
            component: () =>
                import(/* webpackChunkName: "cliente" */ "../pages/cadastros/clientes/ClienteAdd.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/cliente/:id",
            component: () =>
                import(/* webpackChunkName: "cliente" */ "../pages/cadastros/clientes/ClienteAdd.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/concentrador",
            component: () =>
                import(/* webpackChunkName: "concentrador" */ "../pages/cadastros/concentradores/ConcentradorAdd.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/concentrador/:id",
            component: () =>
                import(/* webpackChunkName: "concentrador" */ "../pages/cadastros/concentradores/ConcentradorAdd.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/concentrador/comandos/:id",
            component: () =>
                import(/* webpackChunkName: "concentrador_comando" */ "../pages/cadastros/concentradores/ConcentradorComando.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/concentradores",
            component: () =>
                import(/* webpackChunkName: "concentradores" */ "../pages/cadastros/Concentradores.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/splitters",
            component: () =>
                import(/* webpackChunkName: "splitters" */ "../pages/cadastros/Splitters.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/splitter",
            component: () =>
                import(/* webpackChunkName: "splitter" */ "../pages/cadastros/splitters/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "splitters_add" */ "../pages/cadastros/splitters/SplitterAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "splitters_add" */ "../pages/cadastros/splitters/SplitterAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },
        {
            path: "/condominios",
            component: () =>
                import(/* webpackChunkName: "condominios" */ "../pages/cadastros/Condominios"),
            beforeEnter: checkAuth
        },
        {
            path: "/condominio",
            component: () =>
                import(/* webpackChunkName: "condominio_add" */ "../pages/cadastros/condominios/Index"),
            beforeEnter: checkAuth
        },
        {
            path: "/condominio/:id",
            component: () =>
                import(/* webpackChunkName: "condominio_add" */ "../pages/cadastros/condominios/Index"),
            beforeEnter: checkAuth
        },
        {
            path: "/entroncamentos",
            component: () =>
                import(/* webpackChunkName: "entrocamentos" */ "../pages/cadastros/Entrocamentos"),
            beforeEnter: checkAuth
        },
        {
            path: "/entroncamento/novo",
            component: () =>
                import(/* webpackChunkName: "entrocamento" */ "../pages/cadastros/entrocamentos/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/entroncamento/novo/:lat/:lng",
            component: () =>
                import(/* webpackChunkName: "entrocamento" */ "../pages/cadastros/entrocamentos/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/entroncamento/add/:id",
            component: () =>
                import(/* webpackChunkName: "entrocamento" */ "../pages/cadastros/entrocamentos/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/caixas-conectores",
            component: () =>
                import(/* webpackChunkName: "caixas_conectores" */ "../pages/cadastros/CaixasConectores.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-conector/novo",
            component: () =>
                import(/* webpackChunkName: "caixa_conector" */ "../pages/cadastros/caixas-conectores/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-conector/novo/:lat/:lng",
            component: () =>
                import(/* webpackChunkName: "caixa_conector" */ "../pages/cadastros/caixas-conectores/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-conector/add/:id",
            component: () =>
                import(/* webpackChunkName: "caixa_conector" */ "../pages/cadastros/caixas-conectores/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/reservas-tecnicas",
            component: () =>
                import(/* webpackChunkName: "reservas_tecnicas" */ "../pages/cadastros/ReservasTecnicas.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/reserva-tecnica/novo",
            component: () =>
                import(/* webpackChunkName: "reserva_tecnica" */ "../pages/cadastros/reservas-tecnicas/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/reserva-tecnica/novo/:lat/:lng",
            component: () =>
                import(/* webpackChunkName: "reserva_tecnica" */ "../pages/cadastros/reservas-tecnicas/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/reserva-tecnica/add/:id",
            component: () =>
                import(/* webpackChunkName: "reserva_tecnica" */ "../pages/cadastros/reservas-tecnicas/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/caixas-emendas",
            component: () =>
                import(/* webpackChunkName: "caixas_emendas" */ "../pages/cadastros/CaixasEmendas.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-emenda/novo",
            component: () =>
                import(/* webpackChunkName: "caixa_emenda" */ "../pages/cadastros/caixas-emendas/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-emenda/novo/:lat/:lng",
            component: () =>
                import(/* webpackChunkName: "caixa_emenda" */ "../pages/cadastros/caixas-emendas/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-emenda/add/:id",
            component: () =>
                import(/* webpackChunkName: "caixa_emenda" */ "../pages/cadastros/caixas-emendas/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/caixas-switch",
            component: () =>
                import(/* webpackChunkName: "caixas_switch" */ "../pages/cadastros/CaixasSwitch.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-switch/novo",
            component: () =>
                import(/* webpackChunkName: "caixa_switch" */ "../pages/cadastros/caixas-switch/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-switch/novo/:lat/:lng",
            component: () =>
                import(/* webpackChunkName: "caixa_switch" */ "../pages/cadastros/caixas-switch/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-switch/add/:id",
            component: () =>
                import(/* webpackChunkName: "caixa_switch" */ "../pages/cadastros/caixas-switch/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/atendimento-motivo",
            component: () =>
                import(/* webpackChunkName: "atendimentos-motivo" */ "../pages/atendimentos/Motivos.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/atendimento-motivo/novo",
            component: () =>
                import(/* webpackChunkName: "atendimento-motivo" */ "../pages/atendimentos/motivos/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/atendimento-motivo/add/:id",
            component: () =>
                import(/* webpackChunkName: "atendimento-motivo" */ "../pages/atendimentos/motivos/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/atendimento-acoes",
            component: () =>
                import(/* webpackChunkName: "acoes" */ "../pages/atendimentos/Acoes.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/atendimento-acoes/novo",
            component: () =>
                import(/* webpackChunkName: "acao" */ "../pages/atendimentos/acoes/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/atendimento-acoes/add/:id",
            component: () =>
                import(/* webpackChunkName: "acao" */ "../pages/atendimentos/acoes/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/atendimento/novo/:id_contrato",
            component: () =>
                import(/* webpackChunkName: "atendimentos" */ "../pages/atendimentos/Atendimento.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/pops",
            component: () =>
                import(/* webpackChunkName: "pops" */ "../pages/cadastros/Pops.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/pops/novo",
            component: () =>
                import(/* webpackChunkName: "pop" */ "../pages/cadastros/pops/Index.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/pops/add/:id",
            component: () =>
                import(/* webpackChunkName: "pop" */ "../pages/cadastros/pops/Index.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/caixas-pacpon",
            component: () =>
                import(/* webpackChunkName: "caixas_pacpon" */ "../pages/cadastros/CaixasPacPon.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-pacpon",
            component: () =>
                import(/* webpackChunkName: "caixa_pacpon" */ "../pages/cadastros/caixas-pacpon/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "caixa_pacpon" */ "../pages/cadastros/caixas-pacpon/Index.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "novo/:lat/:lng",
                    component: () =>
                        import(/* webpackChunkName: "caixa_pacpon" */ "../pages/cadastros/caixas-pacpon/Index.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "caixa_pacpon" */ "../pages/cadastros/caixas-pacpon/Index.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },

        {
            path: "/caixas-cto",
            component: () =>
                import(/* webpackChunkName: "caixas_cto" */ "../pages/cadastros/CaixasCTO.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/caixa-cto",
            component: () =>
                import(/* webpackChunkName: "caixa_cto" */ "../pages/cadastros/caixas-cto/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "caixa_cto" */ "../pages/cadastros/caixas-cto/Index.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "novo/:lat/:lng",
                    component: () =>
                        import(/* webpackChunkName: "caixa_cto" */ "../pages/cadastros/caixas-cto/Index.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "caixa_cto" */ "../pages/cadastros/caixas-cto/Index.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },

        {
            path: "/pontos",
            component: () =>
                import(/* webpackChunkName: "pontos" */ "../pages/cadastros/Pontos.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/ponto",
            component: () =>
                import(/* webpackChunkName: "ponto" */ "../pages/cadastros/pontos/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "ponto_add" */ "../pages/cadastros/pontos/PontoAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "ponto_add" */ "../pages/cadastros/pontos/PontoAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },

        {
            path: "/fibras",
            component: () =>
                import(/* webpackChunkName: "fibras" */ "../pages/cadastros/Fibras.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/fibra",
            component: () =>
                import(/* webpackChunkName: "fibra" */ "../pages/cadastros/fibra/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "fibra_add" */ "../pages/cadastros/fibra/FibraAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "fibra_add" */ "../pages/cadastros/fibra/FibraAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },

        {
            path: "/repetidores",
            component: () =>
                import(/* webpackChunkName: "repetidores" */ "../pages/cadastros/Repetidores.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/repetidor",
            component: () =>
                import(/* webpackChunkName: "repetidor" */ "../pages/cadastros/repetidores/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "repetidor_add" */ "../pages/cadastros/repetidores/RepetidorAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "repetidor_add" */ "../pages/cadastros/repetidores/RepetidorAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },
        {
            path: "/smtps",
            component: () =>
                import(/* webpackChunkName: "smtps" */ "../pages/cadastros/Smtps.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/smtp",
            component: () =>
                import(/* webpackChunkName: "smtp" */ "../pages/cadastros/smtps/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "smtp_add" */ "../pages/cadastros/smtps/SmtpAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "smtp_add" */ "../pages/cadastros/smtps/SmtpAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },
        {
            path: "/portas-pon",
            component: () =>
                import(/* webpackChunkName: "portas_pon" */ "../pages/cadastros/PortasPon.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/porta-pon",
            component: () =>
                import(/* webpackChunkName: "porta_pon" */ "../pages/cadastros/porta-pon/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "porta_pon_add" */ "../pages/cadastros/porta-pon/PortaAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "porta_pon_add" */ "../pages/cadastros/porta-pon/PortaAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },
        {
            path: "/vlans",
            component: () =>
                import(/* webpackChunkName: "vlans" */ "../pages/cadastros/Vlans"),
            beforeEnter: checkAuth
        },
        {
            path: "/vlan",
            component: () =>
                import(/* webpackChunkName: "vlan_add" */ "../pages/cadastros/vlan/Index"),
            beforeEnter: checkAuth
        },
        {
            path: "/usuarios",
            component: () =>
                import(/* webpackChunkName: "usuarios" */ "../pages/cadastros/Usuarios.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/usuario/:id",
            component: () =>
                import(/* webpackChunkName: "usuario_add" */ "../pages/cadastros/add/UsuarioAdd.vue"),
            beforeEnter: checkAuth
        },

        {
            path: "/cliente/contratos/:id",
            component: () =>
                import(/* webpackChunkName: "cliente_contrato" */ "../pages/cadastros/clientes/ClienteContratos.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/planos-internet",
            component: () =>
                import(/* webpackChunkName: "planos_internet" */ "../pages/cadastros/PlanosInternet.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/plano-internet",
            component: () =>
                import(/* webpackChunkName: "plano_internet" */ "../pages/cadastros/planos_internet/Index.vue"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "novo",
                    component: () =>
                        import(/* webpackChunkName: "plano_internet_add" */ "../pages/cadastros/planos_internet/PlanoInternetAdd.vue"),
                    beforeEnter: checkAuth
                },
                {
                    path: "add/:id",
                    component: () =>
                        import(/* webpackChunkName: "plano_internet_add" */ "../pages/cadastros/planos_internet/PlanoInternetAdd.vue"),
                    beforeEnter: checkAuth
                }
            ]
        },
        {
            path: "/modelos-switch",
            component: () =>
                import(/* webpackChunkName: "modelos_switch" */ "../pages/cadastros/ModelosSwitch.vue"),
            beforeEnter: checkAuth
        },
        {
            path: "/modelo-switch",
            component: () =>
                import(/* webpackChunkName: "modelo_switch" */ "../pages/cadastros/modelo-switch/Index"),
            beforeEnter: checkAuth,
            children: [
                {
                    path: "",
                    component: () =>
                        import(/* webpackChunkName: "modelo_switch_add" */ "../pages/cadastros/modelo-switch/ModeloSwitchAdd"),
                    beforeEnter: checkAuth
                },
                {
                    path: ":id",
                    component: () =>
                        import(/* webpackChunkName: "modelo_switch_add" */ "../pages/cadastros/modelo-switch/ModeloSwitchAdd"),
                    beforeEnter: checkAuth
                }
            ]
        }
    );
};
